import * as React from 'react';

import { RegisterHero } from './components/register-hero';
import { RegisterRedirectGate } from './register-gate';

export default function Register() {
  return (
    <RegisterRedirectGate>
      <RegisterHero />
    </RegisterRedirectGate>
  );
}
